module.exports = __webpack_public_path__ + "img/ymx.f24f6d15.png";